import styled from "styled-components";
import { theme } from "../../theme";

export const StyledLoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100000000;
  background-color: ${theme.backgroundColor.primaryBlack}77;
  @keyframes animateDot1 {
    0% {
      transform: none;
    }
    50% {
      transform: translateY(10px);
    }
    100% {
      transform: none;
    }
  }
  @keyframes animateDot2 {
    0% {
      transform: none;
    }
    50% {
      transform: translateY(10px);
    }
    100% {
      transform: none;
    }
  }
  @keyframes animateDot3 {
    0% {
      transform: none;
    }
    50% {
      transform: translateY(10px);
    }
    100% {
      transform: none;
    }
  }

  span {
    width: 18px;
    height: 18px;
    display: inline-block;
    border-radius: 50%;
    background-color: ${theme.backgroundColor.primaryWhite};
    margin: 0 5px;
  }
  span:nth-child(1) {
    animation: animateDot1 0.45s infinite;
    animation-delay: 0s;
  }
  span:nth-child(2) {
    animation: animateDot2 0.45s infinite;
    animation-delay: 0.1s;
  }

  span:nth-child(3) {
    animation: animateDot3 0.45s infinite;
    animation-delay: 0.2s;
  }
`;
